import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Spinner, Alert } from 'react-bootstrap';
import * as adminApi from '../../Services/adminApi';

/**
 * The StatCard component now accepts an 'icon' prop which is a string 
 * representing the Font Awesome classes (e.g., 'fas fa-users').
 */
const StatCard = ({ title, value, icon, variant }) => (
    <Card className={`text-white bg-${variant} mb-3 shadow-sm`}>
        <Card.Body>
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <h4 className="mb-0">{value}</h4>
                    <p className="mb-0">{title}</p>
                </div>
                <div className="fs-1 opacity-50">
                    <i className={icon}></i> {/* Changed to use <i> with className */}
                </div>
            </div>
        </Card.Body>
    </Card>
);

const AdminDashboard = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchStats = async () => {
            try {
                setLoading(true);
                // The backend response is an object, no .data needed with fetch
                const statsData = await adminApi.getSiteOverviewStats();
                setStats(statsData);
                setError('');
            } catch (err) {
                setError('Failed to load dashboard statistics.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    if (loading) {
        return <div className="text-center"><Spinner animation="border" /></div>;
    }

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    return (
        <div>
            <h2>Admin Dashboard</h2>
            <p className="text-muted">A quick overview of your site's activity.</p>
            <hr />
            {stats && (
                <Row>
                    <Col md={6} xl={4}>
                        <StatCard title="Total Users" value={stats.totalUsers} icon="fas fa-users" variant="primary" />
                    </Col>
                    <Col md={6} xl={4}>
                        <StatCard title="New Users Today" value={stats.newUsersToday} icon="fas fa-user-plus" variant="info" />
                    </Col>
                    <Col md={6} xl={4}>
                        <StatCard title="Total Listings" value={stats.totalListings} icon="fas fa-list-alt" variant="success" />
                    </Col>
                    <Col md={6} xl={4}>
                        <StatCard title="Active Listings" value={stats.activeListings} icon="fas fa-check-circle" variant="dark" />
                    </Col>
                    <Col md={6} xl={4}>
                        <StatCard title="Total Categories" value={stats.totalCategories} icon="fas fa-tags" variant="secondary" />
                    </Col>
                    <Col md={6} xl={4}>
                        <StatCard title="Pending Reports" value={stats.pendingReports} icon="fas fa-exclamation-triangle" variant="danger" />
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default AdminDashboard;